import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersistMessageReferenceService } from '../persist-message-reference.service';
import { MessageComparisonResult } from '../models/message-comparison-result';

@Component({
    selector: 'view-comparison',
    standalone: true,
    imports: [CommonModule, KENDO_GRID],
    providers: [PersistMessageReferenceService, DatePipe],
    templateUrl: './view-comparison.component.html'
})
export class ViewComparisonComponent implements OnInit {
  @Input() currentId: number;
  @Input() previousId: number;

  public result: MessageComparisonResult | null = null;
  public loading: boolean = true;
  public error: string = '';

  private static readonly ISO_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

  constructor(
    public activeModal: NgbActiveModal,
    private persistMessageReferenceService: PersistMessageReferenceService,
    private datePipe: DatePipe
  ) {}

  formatValue(value: string | null): string {
    if (value === null || value === undefined) return '(null)';
    if (ViewComparisonComponent.ISO_DATETIME_REGEX.test(value)) {
      return this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss') ?? value;
    }
    return value;
  }

  ngOnInit(): void {
    this.persistMessageReferenceService.compare(this.currentId, this.previousId).subscribe({
      next: (result) => {
        this.result = result;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error = err?.message || 'Failed to load comparison';
        console.error('Error loading comparison:', err);
      }
    });
  }
}
